import { DissolutionProvider } from './dissolutionProvider';

export function workflowProviderFactory(provider: any) {
    return () => provider.load();
  }